import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { Button, Alert, Container, Card } from 'react-bootstrap';

const GoogleAuthTest = () => {
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  const testLogin = useGoogleLogin({
    scope: 'https://www.googleapis.com/auth/calendar',
    onSuccess: (tokenResponse) => {
      console.log('Test login success:', tokenResponse);
      setResult(`✅ Başarılı! Token alındı: ${tokenResponse.access_token?.substring(0, 30)}...`);
      setError('');
      
      // Test Calendar API call
      testCalendarAPI(tokenResponse.access_token);
    },
    onError: (error) => {
      console.error('Test login error:', error);
      setError(`❌ Hata: ${error.error} - ${error.error_description || 'Bilinmeyen hata'}`);
      setResult('');
    },
  });

  const testCalendarAPI = async (accessToken) => {
    try {
      const response = await fetch('https://www.googleapis.com/calendar/v3/calendars/primary', {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setResult(prev => prev + `\n✅ Calendar API çalışıyor! Takvim: ${data.summary}`);
      } else {
        setResult(prev => prev + `\n❌ Calendar API hatası: ${response.status}`);
      }
    } catch (err) {
      setResult(prev => prev + `\n❌ Calendar API test hatası: ${err.message}`);
    }
  };

  return (
    <Container className="mt-5">
      <Card>
        <Card.Header>
          <h4>Google OAuth & Calendar API Test</h4>
        </Card.Header>
        <Card.Body>
          <p>Bu sayfa Google OAuth ve Calendar API yapılandırmanızı test eder.</p>
          
          <div className="mb-3">
            <strong>Mevcut Ayarlar:</strong><br />
            <small>
              <strong>Origin:</strong> <code>{window.location.origin}</code><br />
              <strong>Client ID:</strong> <code>{process.env.REACT_APP_GOOGLE_CLIENT_ID?.substring(0, 30)}...</code>
            </small>
          </div>

          {error && <Alert variant="danger">{error}</Alert>}
          {result && (
            <Alert variant="success">
              <pre style={{whiteSpace: 'pre-wrap', margin: 0}}>{result}</pre>
            </Alert>
          )}

          <Button variant="primary" onClick={() => testLogin()}>
            Google OAuth & Calendar API Test Et
          </Button>

          <div className="mt-4">
            <h6>Google Cloud Console Kontrol Listesi:</h6>
            <ol className="small mb-0">
              <li>APIs & Services → Library → Google Calendar API (✓ Enabled)</li>
              <li>APIs & Services → Credentials → OAuth 2.0 Client ID</li>
              <li>Authorized JavaScript origins: <code>{window.location.origin}</code></li>
              <li>Authorized redirect URIs: <code>{window.location.origin}</code></li>
              <li>OAuth consent screen → Test users → Email adresiniz</li>
              <li>OAuth consent screen → Scopes → calendar scope eklendi</li>
            </ol>
          </div>

          <div className="mt-3 p-3 bg-warning rounded">
            <h6>Yaygın Hatalar:</h6>
            <ul className="small mb-0">
              <li><strong>redirect_uri_mismatch:</strong> URI'lar eşleşmiyor</li>
              <li><strong>access_denied:</strong> Test kullanıcısı değilsiniz</li>
              <li><strong>invalid_client:</strong> Client ID yanlış</li>
              <li><strong>popup_closed_by_user:</strong> Popup'ı kapatmayın</li>
            </ul>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default GoogleAuthTest;